(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["slidersummer"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initSlider(section) {
    var track    = section.querySelector('.bss-track');
    var cards    = section.querySelectorAll('.bss-card');
    var btnPrev  = section.querySelector('.bss-arrow--prev');
    var btnNext  = section.querySelector('.bss-arrow--next');
    var toast    = section.querySelector('.bss-toast');
    var autoplay = section.dataset.autoplay === 'true';
    var speed    = parseInt(section.dataset.speed, 10) || 4000;
    var showArrowsMobile = section.dataset.showArrowsMobile === 'true';

    if (!track || !cards.length) return;

    if (showArrowsMobile && window.innerWidth < 768) {
      if (btnPrev) btnPrev.classList.add('bss-arrow--mobile-visible');
      if (btnNext) btnNext.classList.add('bss-arrow--mobile-visible');
    }

    var current    = 0;
    var total      = cards.length;
    var autoTimer  = null;
    var isHovering = false;

    function goTo(index) {
      if (index < 0)      index = total - 1;
      if (index >= total) index = 0;
      current = index;
      var card   = cards[current];
      var offset = card.offsetLeft - track.offsetLeft;
      track.scrollTo({ left: offset, behavior: 'smooth' });
    }

    if (btnPrev) btnPrev.addEventListener('click', function() { resetTimer(); goTo(current - 1); });
    if (btnNext) btnNext.addEventListener('click', function() { resetTimer(); goTo(current + 1); });

    track.addEventListener('scroll', debounce(function() {
      var center  = track.scrollLeft + track.clientWidth / 2;
      var closest = 0;
      var minDist = Infinity;
      cards.forEach(function(card, i) {
        var cardCenter = card.offsetLeft + card.offsetWidth / 2;
        var dist = Math.abs(center - cardCenter);
        if (dist < minDist) { minDist = dist; closest = i; }
      });
      current = closest;
    }, 80));

    function startTimer() {
      if (!autoplay) return;
      clearInterval(autoTimer);
      autoTimer = setInterval(function() {
        if (!isHovering) goTo(current + 1);
      }, speed);
    }
    function resetTimer() { clearInterval(autoTimer); startTimer(); }

    track.addEventListener('mouseenter', function() { isHovering = true; });
    track.addEventListener('mouseleave', function() { isHovering = false; });
    track.addEventListener('touchstart', function() { isHovering = true;  resetTimer(); }, { passive: true });
    track.addEventListener('touchend',   function() { isHovering = false; resetTimer(); }, { passive: true });

    section.querySelectorAll('.bss-cart-btn').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var variantId = btn.dataset.variantId;
        if (!variantId) return;
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
        .then(function(res) {
          if (!res.ok) throw new Error('Cart error');
          return res.json();
        })
        .then(function() {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          fetch('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              document.querySelectorAll('[data-cart-count]').forEach(function(el) {
                el.textContent = cart.item_count;
              });
            });
          showToast();
        })
        .catch(function(err) { console.error('[BSS] cart error:', err); })
        .finally(function() { btn.disabled = false; });
      });
    });

    function showToast() {
      if (!toast) return;
      toast.classList.add('bss-toast--show');
      setTimeout(function() { toast.classList.remove('bss-toast--show'); }, 2800);
    }

    function debounce(fn, delay) {
      var t;
      return function() {
        var args = arguments;
        clearTimeout(t);
        t = setTimeout(function() { fn.apply(null, args); }, delay);
      };
    }

    /* Avvia autoplay dopo che il DOM è completamente pronto */
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      setTimeout(startTimer, 200);
    } else {
      document.addEventListener('DOMContentLoaded', function() {
        setTimeout(startTimer, 200);
      });
    }
  }

  /* Inizializza tutte le sezioni slider presenti nella pagina */
  document.querySelectorAll('.bss-section').forEach(function(section) {
    initSlider(section);
  });

})();

  } catch(e) { console.error(e); }
})();
})();
